import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPrint } from 'react-icons/fa';
import TextArea from '../../../../components/TextArea';
import InputMoney from '../../../../components/InputMoney';
import { formatPrice } from '../../../../utils/funcoes';
import api from '../../../../services/api';
import { IContrato } from '../../../Usuario/Contrato/Cadastro';
import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';
import getResponseErrors from '../../../../utils/getResponseErrors';
import Loading from '../../../../components/Loading';
import ReciboPagamentoMedico from '../Recibo';
import { IPagamentosMedicosBase } from '../DespesasPagamentoMedico';
import Modal from '../../../../components/Modal';

// import getResponseErrors from '../../../../utils/getResponseErrors';

// import { PacienteLinha, PacienteLista } from '../styles';
// import { htmlDecode } from '../../../../utils/funcoes';
// import { IListagemVencendo } from '..';

// import { Spinner } from '../../../../components/Agendamento/styles';

type Props = {
  despesa: {
    codigos: number[];
    totalPago: number;
    totalCobrado: number;
    quantidade: number;
    valorAPagar: number;
    nomeMedico: string;
  };
  contrato: IContrato;
  handleFecharModal(): void;
};

interface IFormBusca {
  valor: number;
  observacao: string;
}

const DespesaMedico: React.FC<Props> = ({
  despesa,
  contrato,
  handleFecharModal,
}) => {
  const formRefBusca = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showModalRecibo, setShowModalRecibo] = useState(false);
  const [pagamentoMedico, setPagamentoMedico] = useState<
    IPagamentosMedicosBase | undefined
  >(undefined);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);

      const diferenca = parseFloat(
        (Number(dados.valor) - despesa.valorAPagar).toFixed(2),
      );
      if (diferenca !== 0 && dados.observacao.trim() === '') {
        addToast({
          type: 'error',
          title: 'Campo Observação requerido',
          description:
            'Observação requerida quando valor pago difere do valor apurado.',
          timeAlive: 5000,
        });
        setLoading(false);
        return;
      }

      const dadosCreate = {
        UsuMedCodigo: contrato.ConUsuCodigo,
        agendamentos: despesa.codigos.join(),
        valorApurado: despesa.valorAPagar,
        acrescimoDesconto: diferenca,
        motivo: dados.observacao,
      };
      try {
        const response = await api.post<IPagamentosMedicosBase>(
          `/pagamentosmedicos`,
          dadosCreate,
        );

        setLoading(false);
        // handleFecharModal();
        setPagamentoMedico(response.data);
        setShowModalRecibo(true);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível adicionar despesa médica',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [despesa, contrato.ConUsuCodigo, addToast],
  );

  return (
    <>
      {loading && <Loading />}
      {showModalRecibo && pagamentoMedico && (
        <Modal
          show={showModalRecibo}
          titulo="Recibo"
          handleFecharModal={() => {
            setShowModalRecibo(false);
            handleFecharModal();
          }}
        >
          <ReciboPagamentoMedico recibo={pagamentoMedico.recibo} />
          <Link
            data-id={pagamentoMedico.id}
            type="button"
            style={{ padding: '1px 8px' }}
            // onClick={
            //   () => handleShowRecibo(rel.recibo)
            //   // eslint-disable-next-line react/jsx-curly-newline
            // }
            to={`/impressaopagamentoMedico/${pagamentoMedico.id}`}
            target="_blank"
          >
            <FaPrint size={14} />
          </Link>
        </Modal>
      )}
      <Row className="border mt-1 mx-2 px-2 rounded">
        <Col>
          <Row className=" py-3">
            <Col>
              Médico: <b>{despesa.nomeMedico}</b>
            </Col>
          </Row>
          <Row className=" py-3">
            <Col>
              Tipo Contrato: <b>{contrato.ConTipo}</b>
            </Col>
            <Col>
              Qtde Atendido: <b>{despesa.quantidade}</b>
            </Col>
            <Col>
              Valor Apurado: <b>{formatPrice(despesa.valorAPagar)}</b>
            </Col>
          </Row>
        </Col>
      </Row>
      <Form
        ref={formRefBusca}
        initialData={{ valor: despesa.valorAPagar }}
        onSubmit={handleSubmitBusca}
      >
        <Row className="border mt-3 mx-2 p-2 rounded">
          <Col>
            <TextArea name="observacao" label="Observação" rows={4} />
          </Col>{' '}
          <Col md={3}>
            <Row>
              <Col>
                {' '}
                <InputMoney
                  label="Valor"
                  name="valor"
                  autoComplete="nope"
                  placeholder="Valor"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <br />
                <Button type="submit" size="sm" variant="primary">
                  Gerar Despesa
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default DespesaMedico;
